import React, { useState, useEffect } from 'react';
import { fetchStudents, assignStudentToGroup } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const AssignStudentToGroupModal = ({ onClose, onAssigned, groupId }) => {
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const studentsResponse = await fetchStudents({
                    limit: 150,
                    page: 1,
                    main_status: 3
                });
                setStudents(studentsResponse.data || []);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(false);

        if (!selectedStudent) {
            setError('Please select a student.');
            return;
        }

        try {
            await assignStudentToGroup(selectedStudent, groupId);
            setSuccess(true);
            setTimeout(() => {
                onAssigned();
            }, 2000);
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Assign Student to Group</h2>
                {error && <div className="error-message">{error}</div>}
                {success && <div className="success-message">Student assigned successfully!</div>}
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <select
                                value={selectedStudent}
                                onChange={(e) => setSelectedStudent(e.target.value)}
                                required
                            >
                                <option value="">Select a student</option>
                                {students.map((student) => (
                                    <option key={student.id} value={student.id}>
                                        {student.first_name} {student.last_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="actions-centered">
                            <button type="button" className="cancel-button text-button" onClick={onClose}>Cancel</button>
                            <button type="submit" className="submit-button text-button">Assign</button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default AssignStudentToGroupModal;
